import RelatorioAbas from './RelatorioAbas';
import DecisaoCiclo from './DecisaoCiclo';
import { narrativaCiclo } from '../format';

// Corpo do modo 'acoes' do modal: narrativa + contestacao (se houver) + relatorio + decisao.
const CockpitCiclo = ({ ciclo, isAdmin, contestacao, anotacao, setAnotacao, salvarAnotacao, onRecalcular, onReenviar, onFaturar, onContestar, onRecalculadoSalvo }) => (
    <div className='px-6 py-5 flex flex-col gap-4'>
        <p className='text-sm text-gray-700 dark:text-gray-200 bg-gray-50 dark:bg-gray-700 rounded-lg px-3 py-2'>{narrativaCiclo(ciclo)}</p>

        {ciclo.status === 'contestado' && contestacao && (
            <div className='space-y-2'>
                <span className='text-xs font-semibold text-gray-500'>O QUE O CLIENTE ESCREVEU</span>
                <p className='bg-orange-50 dark:bg-gray-900 dark:text-gray-100 rounded-lg p-3 whitespace-pre-wrap'>{contestacao.mensagem || '—'}</p>
                {(contestacao.nome_contato || contestacao.email_contato) && (
                    <p className='text-xs text-gray-500'>{contestacao.nome_contato} {contestacao.email_contato ? `• ${contestacao.email_contato}` : ''}</p>
                )}
                <label className='block text-xs font-semibold text-gray-500 mb-1 mt-2'>Anotação interna (só nós vemos)</label>
                <textarea rows={2} value={anotacao} onChange={(e) => setAnotacao(e.target.value)}
                    className='w-full border rounded-lg p-2 dark:bg-gray-700 dark:text-white' placeholder='Registro do tratamento dado à contestação' />
                <button type='button' onClick={salvarAnotacao} className='px-3 py-1.5 bg-gray-200 dark:bg-gray-600 dark:text-white rounded-lg text-sm'>Salvar anotação</button>
            </div>
        )}

        <RelatorioAbas idCiclo={ciclo.id} status={ciclo.status} onSaved={onRecalculadoSalvo} />

        <DecisaoCiclo ciclo={ciclo} isAdmin={isAdmin}
            onRecalcular={onRecalcular} onReenviar={onReenviar} onFaturar={onFaturar} onContestar={onContestar} />

        <a href={`/faturamento/${ciclo.hash_acesso}`} target='_blank' rel='noreferrer'
            className='text-sm text-vox-blue-600 hover:underline self-start'>Ver o que o cliente recebe</a>
    </div>
);

export default CockpitCiclo;
